import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import lodash from "lodash";
import { colors } from "../../constants/colors";
import Paper from "@mui/material/Paper";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import Divider from "@mui/material/Divider";
import CommonButton from "../CommonButton";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { tableGridLabelsMapping } from "../../Utils/helper";
import CommonModal from "../Modal/CommonModal";
import { Box, display } from "@mui/system";
import PdfOpener from "../Modal/PdfOpener";
import { Fragment } from "react";
import { useSelector } from "react-redux";
import { typeOfAudio, typeOfPlayer } from "../../Utils/helper";
import AudioPlayer from "../Player/AudioPlayer";
import VideoPlayer from "../Player/VideoPlayer";
import CustomTooltip from "../CustomTooltip/CustomTooltip";
import ReactPanZoom from "react-image-pan-zoom-rotate";
import DocxOpener from "../Modal/DocxOpener";
import { imageBaseURL } from "../../constants/utils";
import HeicViewer from "../Player/HeicViewer";
import useDownloadFile from "../../customHook/useDownloadFile";
import { downloadSupportedTypes } from "../../constants/utils";
import TIFFFileViewer from "../TiffViewer";
import useToaster from "../../customHook/useToaster";
import { Check } from "@mui/icons-material";
import NotInterestedOutlinedIcon from "@mui/icons-material/NotInterestedOutlined";
import RtfViewer from "../VendorUpload/RtfViewer";
import DocumentRenderer from "../DocumentRenderer";

const fieldStyles = {
  color: colors?.gray,
  fontWeight: 400,
  fontSize: "11px",
  wordWrap: "break-word",
  textTransform: "capitalize",
};

const TableGrid = ({
  gridContent = {},
  label = "Documents",
  isDocument = false,
  forApprovalInvoices = false,
  backgroundColor,
  boxShadow,
  padding,
  rowSpacing,
  documentDetails = [],
  onClickDocument = () => {},
  onUploadButtonClick = () => {},
  xs = 2,
  InvestigationLabel,
  uploadButton = false,
  isVendorBlock = false,
  isButton = false,
  invoice = false,
  isCreateCase = false,
  isMultipleVendorBlockData = false,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState({});

  const { lobName } = useSelector((state) => state?.CaseDescriptionSlice);
  const { showToast } = useToaster();
  const truncateMiddleText = (str, maxLength) => {
    if (str?.length <= maxLength) {
      return str;
    }
    const firstPart = str?.substr(0, maxLength / 2);
    const lastPart = str?.substr(str?.length - maxLength / 2);
    return `${firstPart}.....${lastPart}`;
  };

  // custom hook for downloading the avi videos
  const { downloadFile } = useDownloadFile();

  // let chargeEntries = Object.entries(gridContent?.["charge_details"] || {});
  let taxEntries = Object.entries(gridContent?.["tax_details"] || {});
  let charges = (gridContent?.["charge_details"] || [])?.map((item) => [
    item?.charge_name,
    item?.charge_amount,
  ]);
  let taxes =
    taxEntries?.length > 1 ? taxEntries?.slice(0, taxEntries?.length - 1) : [];

  gridContent = invoice
    ? {
        ...gridContent,
        charge_name: charges?.map((item) => item?.[0] || "-")?.join("\n"),
        charge_amount: charges?.map((item) => item?.[1] || "-")?.join("\n"),
        tax: taxes?.map((item) => item?.[0] || "-")?.join("\n"),
        tax_amount: taxes?.map((item) => item?.[1] || "-")?.join("\n"),
      }
    : gridContent;

  let caseSearchValue = useSelector((state) => state.SearchSlice.searchValue);

  const documentViewHandler = (docData) => {
    const fileType = docData?.document_name?.split(".").pop(); // Get the file type
    setSelectedDoc({ ...docData });
    downloadSupportedTypes.includes(fileType)
      ? downloadFile(docData?.document_path, docData?.document_name, fileType)
      : setIsModalOpen(true);
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case "approved":
        return (
          <Check
            sx={{
              color: "#58E39E",
              width: "26.8px",
              height: "18.20px",
            }}
          />
        );
      case "rejected":
        return (
          <NotInterestedOutlinedIcon
            sx={{ color: "#F87A83", width: "26.8px", height: "18.20px" }}
          />
        );
      default:
        return null;
    }
  };

  const sortedGridContent = Object.keys(gridContent)?.sort((a, b) => {
    let gridContentKeys = Object.keys(gridContent);
    if (
      gridContentKeys.includes("policy_start_date") ||
      gridContentKeys.includes("charge_name")
    ) {
      return (
        Object.keys(tableGridLabelsMapping).indexOf(a) -
        Object.keys(tableGridLabelsMapping).indexOf(b)
      );
    } else {
      return 0;
    }
  });

  // const onNumberClickHandler = async () => {
  //   // temp code
  //   try {
  //     const response = await fetch(
  //       "https://in1-ccaas-api.ozonetel.com/ca_apis/PhoneManualDial",
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json", // Add other headers if needed, like authorization
  //           // Authorization: token,
  //           apiKey: "KK86819c3c4ac5510bf97422548f739524",
  //         },
  //         body: JSON.stringify({
  //           userName: "hdfcergo_demo",
  //           custNumber: "9004077702",
  //           phoneName: "atulparab",
  //           campaignName: "Inbound_918040363274",
  //           did: "918040363274",
  //           uui: "NA",
  //           checkStatus: true,
  //         }),
  //       }
  //     );
  //     const result = await response.json();
  //     if (response.ok) {
  //       showToast("Call triggered successfully", "success", true);
  //       console.log("Call triggered successfully", result); // handle success
  //     } else {
  //       console.error("Call failed", result); // handle API error
  //     }
  //   } catch (error) {
  //     console.error("Network error:", error);
  //   }
  // };

  /*
 Display logic for comment Value:
 Priority order:
 1. If name is not present show "-"
 2. If comment is present  show comment
 3. If comment is not present but flag exists show flag
 4. If name exists but neither comment nor flag exists show "Pending"
*/
  const displayCommentValue = (item) => {
    if (!item?.name) return "-";
    if (item?.comment) return item.comment;
    if (item?.flag) return item.flag;
    return "Pending";
  };

  return (
    <Paper
      sx={{
        padding: padding ? padding : "0px 16px 16px 16px",
        boxShadow,
        backgroundColor,
        marginTop: "12px",
      }}
      elevation={4}
    >
      {InvestigationLabel ? (
        <Typography
          sx={{ pl: "1.6rem", pt: "2rem", fontWeight: 600, fontSize: "1.3rem" }}
        >
          {InvestigationLabel}
        </Typography>
      ) : null}
      {isButton ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <CommonButton
            filledButton={true}
            label="Case found in Open Cases - View"
            endIcon={
              <img
                src={`${imageBaseURL}/Svg/rightArrow.svg`}
                alt="rightArrow"
                loading="lazy"
              />
            }
            isEndIcon={true}
            fontSize="1.4rem"
            sx={{
              width: "auto",
              height: "3.5rem",
              lineHeight: "100%",
              marginTop: "6px",
            }}
            // onClick={addDescriptionHandlerClick}
          />
        </div>
      ) : null}
      <Grid
        container
        spacing={2}
        sx={{ margin: 0 }}
        rowSpacing={rowSpacing || rowSpacing === 0 ? rowSpacing : 3}
      >
        {Object.keys(gridContent).length
          ? sortedGridContent?.map((item, index) => {
              let gridVal = "-";
              // if (gridContent[item]) {
              if (gridContent[item] === true) {
                gridVal = "Active";
              } else if (gridContent[item] === false) {
                gridVal = "In Active";
              } else if (lodash.isEmpty(gridContent[item]?.toString())) {
                gridVal = "-";
              } else if (typeof gridContent[item] === "object") {
                gridVal = "-";
              } else {
                gridVal = gridContent[item];
              }
              // }
              let gridValWithTooltip = (
                <CustomTooltip id={`${item}-${index}`} content={gridVal} />
              );
              return (isVendorBlock ||
                tableGridLabelsMapping[item] ||
                isCreateCase) &&
                item !== "documents" ? (
                <Grid item xs={xs} key={gridVal + index}>
                  <Grid
                    container
                    sx={{ margin: 0 }}
                    rowSpacing={rowSpacing || rowSpacing === 0 ? rowSpacing : 1}
                  >
                    <Grid item xs={12} sx={fieldStyles}>
                      <Grid item xs={12} sx={fieldStyles}>
                        {isVendorBlock || isCreateCase
                          ? `${item?.split("_")?.join(" ")}:`
                          : `${tableGridLabelsMapping[item]}:`}
                      </Grid>
                      <Grid
                        item
                        xs={8} //12
                        sx={{
                          color: "black",
                          fontWeight: 500,
                          fontSize: "12px",
                          wordWrap: "break-word",
                          marginTop: "5px",
                          whiteSpace:
                            item === "charge_name" ||
                            item === "charge_amount" ||
                            item === "tax" ||
                            item === "tax_amount"
                              ? "pre-line"
                              : "inherit",
                        }}
                      >
                        {caseSearchValue == gridVal ? (
                          <span className="highlight">
                            {gridVal?.toString()?.length > 0
                              ? gridValWithTooltip
                              : "-"}
                          </span>
                        ) : invoice ? (
                          tableGridLabelsMapping[item] === "Charge Name" ? (
                            <span style={{ display: "block" }}>
                              {gridContent?.["charge_details"]?.map(
                                (val, idx) => (
                                  <span
                                    key={`charge-name-line-${idx}`}
                                    style={{
                                      display: "-webkit-box",
                                      WebkitLineClamp: 1,
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      WebkitBoxOrient: "vertical",
                                      // display: "block",
                                      // lineHeight: "1.59rem",
                                    }}
                                  >
                                    <CustomTooltip
                                      id={index}
                                      content={val?.charge_name?.toString()}
                                      linesVisible={1}
                                    />
                                  </span>
                                )
                              )}
                            </span>
                          ) : tableGridLabelsMapping[item] ===
                            "Charge Amount" ? (
                            gridContent?.["charge_details"]?.map(
                              (val, index) => (
                                <span
                                  style={{
                                    display: "-webkit-box",
                                    WebkitLineClamp: 1,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    WebkitBoxOrient: "vertical",
                                  }}
                                  key={index}
                                >
                                  {val?.charge_amount?.toString() || "-"}
                                </span>
                              )
                            )
                          ) : gridVal?.toString()?.length > 0 ? (
                            gridVal
                          ) : (
                            "-"
                          )
                        ) : ["BIMA Saathi Location"].includes(
                            tableGridLabelsMapping[item]
                          ) ? (
                          <CustomTooltip
                            id={index}
                            content={gridVal}
                            linesVisible={1}
                          />
                        ) : ["Customer Reg. Mobile No."].includes(
                            tableGridLabelsMapping[item]
                          ) ? (
                          <span
                          // style={{
                          //   textDecoration: "underline",
                          //   cursor: "pointer",
                          // }}
                          // onClick={onNumberClickHandler}
                          >
                            {gridVal?.toString()?.length > 0 ? gridVal : "-"}
                          </span>
                        ) : (
                          <span>
                            {gridVal?.toString()?.length > 0 ? gridVal : "-"}
                          </span>
                        )}

                        {(item === "charge_name" ||
                          item === "tax" ||
                          item === "charge_amount" ||
                          item === "tax_amount") && (
                          <Fragment>
                            <br />
                            <br />
                            {item === "charge_name" || item === "tax" ? (
                              <span style={fieldStyles}>Total:</span>
                            ) : item === "charge_amount" ? (
                              <span>
                                {gridContent?.["charge_total"] || "-"}
                              </span>
                            ) : item === "tax_amount" ? (
                              <span>
                                {gridContent?.["tax_details"]?.["total"] || "-"}
                              </span>
                            ) : (
                              ""
                            )}
                          </Fragment>
                        )}
                        {item === "tds_per" && gridContent?.["tds_per"] && (
                          <span>{"%"}</span>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              ) : null;
            })
          : !isMultipleVendorBlockData && (
              <div
                style={{
                  margin: "20px 7px",
                  display: "flex",
                  width: "100%",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "grey",
                }}
              >
                <h3>No data</h3>
              </div>
            )}
      </Grid>
      {invoice && (
        <Box sx={{ px: 2, marginTop: "55px" }}>
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
            Previous Approvals
          </Typography>
          {gridContent?.comments?.map((item, index) => (
            <Grid
              container
              alignItems="flex-start"
              spacing={2}
              key={index}
              sx={{ mb: 2 }}
            >
              {/* Left Column: Role, Name, Date */}
              <Grid item xs={12} sm={2}>
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontSize: "11px",
                    fontWeight: "400",
                    color: "#666666",
                    marginBottom: "8px",
                  }}
                >
                  {item?.role?.toUpperCase() || "-"}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "12px",
                    fontWeight: "500",
                    color: "#3A3A3A",
                    marginBottom: "8px",
                  }}
                >
                  {item?.name || "-"}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ fontSize: "12px", fontWeight: "500", color: "#3A3A3A" }}
                >
                  {item?.time || "-"}
                </Typography>
              </Grid>

              {/* Center Column: Label + Icon , then Comment */}
              <Grid item xs={12} sm={10}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="subtitle2"
                    sx={{
                      fontSize: "11px",
                      fontWeight: "400",
                      color: "#666666",
                    }}
                  >
                    Comment:
                  </Typography>

                  <Box sx={{ minWidth: "24px" }}>
                    {getStatusIcon(item?.flag)}
                  </Box>
                </Box>

                {/* Comment Text Below */}
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "12px",
                    fontWeight: "500",
                    mt: 1,
                    wordBreak: "break-word",
                  }}
                >
                  {displayCommentValue(item)}
                </Typography>
              </Grid>
            </Grid>
          ))}
        </Box>
      )}

      {isDocument && (
        <>
          {forApprovalInvoices ? "" : <Divider sx={{ marginTop: 3 }} />}
          <Grid
            container
            spacing={1}
            sx={{ margin: "10px 0 0 0", paddingLeft: 1 }}
          >
            <Grid item xs={6}>
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: "13px",
                  wordWrap: "break-word",
                }}
              >
                {label}
              </Typography>
            </Grid>
            <Grid
              item
              xs={6}
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                paddingRight: "1.1rem",
              }}
            >
              {uploadButton && (
                <CommonButton
                  onClick={onUploadButtonClick}
                  isIcon
                  sx={{ width: "20%", height: "25px" }}
                  label="Upload"
                  fontSize={"1.2rem"}
                  endIcon={<FileUploadOutlinedIcon />}
                  isEndIcon={true}
                  isColor
                  removeBorder
                  isHover
                  hoverColor={"#E8505B"}
                  textColor="white"
                  backgroundColor={"#E8505B"}
                />
              )}
            </Grid>
            {/* {Check if documentDetails is an array;if so,wrap it with an empty category label} */}
            {(Array.isArray(documentDetails)
              ? [["", documentDetails]] // If array,set category as an empty string to match it with obj format map function
              : Object.entries(documentDetails)
            ) // If object,get entries as [category,items]
              .map(([category, items], index, arr) => (
                <Grid
                  item
                  xs={12}
                  key={category}
                  sx={{
                    marginBottom: "3rem",
                    borderBottom:
                      index !== arr.length - 1 // apply bottom border to all except last
                        ? "1px solid rgba(224, 224, 224, 1)"
                        : "none",
                  }}
                >
                  {category && (
                    <Typography
                      variant="h6"
                      sx={{ marginBottom: "1rem", fontWeight: 500 }}
                    >
                      {category.toUpperCase()}
                    </Typography>
                  )}

                  <Grid
                    container
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                    }}
                  >
                    {items.map((item, index) => (
                      <Fragment key={index}>
                        <Grid
                          container
                          lg={2}
                          md={3}
                          sm={4}
                          xs={12}
                          sx={{
                            width: "17rem",
                            height: "auto",
                            minHeight: "42px",
                            maxHeight: "70px",
                            background: "#FAFAFA",
                            border: "1px solid #E8E8E8",
                            borderRadius: "4px",
                            marginRight: "4rem",
                            marginBottom: "2rem",
                            cursor: "pointer",
                          }}
                          key={index}
                          onClick={() => documentViewHandler(item)}
                        >
                          <Grid item xs={2.5} sx={{ padding: "1rem" }}>
                            <img
                              src={`${imageBaseURL}/pdf-sign.svg`}
                              alt="pdf-sign"
                              loading="lazy"
                            />
                          </Grid>
                          <Grid
                            item
                            xs={9.5}
                            sx={{ paddingTop: "0.8rem", paddingLeft: "0.5rem" }}
                          >
                            <span title={item?.document_name}>
                              <Typography
                                sx={{
                                  fontSize: "1.2rem",
                                  lineHeight: "1.5rem",
                                }}
                              >
                                {truncateMiddleText(item?.document_name, 10)}
                              </Typography>
                              <Typography sx={{ fontSize: "0.8rem" }}>
                                {item?.document_size}
                              </Typography>
                            </span>
                          </Grid>
                          {(item?.upload_date || item?.employee_name) && (
                            <Grid
                              item
                              sx={{
                                borderTop: "1px solid #E8E8E8",
                                width: "100%",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              {item?.employee_name && (
                                <Typography
                                  sx={{
                                    fontSize: "0.8rem",
                                    padding: "0.2rem 1rem",
                                  }}
                                >
                                  {"Name: " + item?.employee_name}
                                </Typography>
                              )}
                              <Typography
                                sx={{
                                  fontSize: "0.8rem",
                                  padding: "0.2rem 1rem",
                                }}
                              >
                                {item?.upload_date}
                              </Typography>
                            </Grid>
                          )}
                        </Grid>
                      </Fragment>
                    ))}
                  </Grid>
                </Grid>
              ))}

            <CommonModal
              open={isModalOpen}
              showCrossIcon={true}
              width="70%"
              height="70%"
              onClose={() => {
                setIsModalOpen(false);
              }}
              showDownloadIcon={lobName === "A&H"}
              downloadFilePath={selectedDoc?.document_path}
              downloadFileName={selectedDoc?.document_name}
              fullsize={
                !typeOfAudio?.includes(
                  selectedDoc?.document_name?.split(".")?.pop()
                )
              }
            >
              <Box sx={{ marginTop: "1rem" }}>
                {/* {selectedDoc?.document_name?.split(".")?.pop() === "pdf" ||
                selectedDoc?.document_name?.split(".")?.pop() === "PDF" ? (
                  <PdfOpener
                    path={selectedDoc?.document_path}
                    type={selectedDoc?.document_name
                      ?.split(".")
                      ?.pop()
                      ?.toLowerCase()}
                  />
                ) : ["doc", "docx"].includes(
                    selectedDoc?.document_name?.split(".")?.pop().toLowerCase()
                  ) ||
                  selectedDoc?.document_name
                    ?.split(".")
                    ?.pop()
                    .toLowerCase() === "xlsx" ? (
                  <DocxOpener path={selectedDoc?.document_path} />
                ) : typeOfAudio?.includes(
                    selectedDoc?.document_name?.split(".")?.pop().toLowerCase()
                  ) ? (
                  <AudioPlayer
                    src={selectedDoc?.document_path}
                    type={selectedDoc?.document_name
                      ?.split(".")
                      ?.pop()
                      .toLowerCase()}
                  />
                ) : typeOfPlayer?.includes(
                    selectedDoc?.document_name?.split(".")?.pop().toLowerCase()
                  ) ? (
                  <VideoPlayer
                    width="100%"
                    height="90%"
                    src={selectedDoc?.document_path}
                    type={selectedDoc?.document_name
                      ?.split(".")
                      ?.pop()
                      .toLowerCase()}
                  />
                ) : ["tif", "tiff"].includes(
                    selectedDoc?.document_name?.split(".")?.pop().toLowerCase()
                  ) ? (
                  <TIFFFileViewer tiff={selectedDoc?.document_path} />
                ) : ["rtf"].includes(
                    selectedDoc?.document_name?.split(".")?.pop().toLowerCase()
                  ) ? (
                  <RtfViewer rtfContent={selectedDoc?.document_path} />
                ) : selectedDoc?.document_name
                    ?.split(".")
                    ?.pop()
                    .toLowerCase() === "heic" ||
                  selectedDoc?.document_name
                    ?.split(".")
                    ?.pop()
                    .toLowerCase() === "heif" ? (
                  <HeicViewer selectedDoc={selectedDoc} />
                ) : (
                  <div
                    style={{
                      position: "relative",
                      overflow: "hidden",
                    }}
                  >
                    <ReactPanZoom
                      alt={selectedDoc?.document_path}
                      image={selectedDoc?.document_path}
                    />
                  </div>
                )} */}
                <DocumentRenderer selectedDoc={selectedDoc} />
              </Box>
            </CommonModal>

            {/* <Grid item xs={2}>
            Doc 1
          </Grid>
          <Grid item xs={2}>
            Doc 2
          </Grid>
          <Grid item xs={2}>
            Doc 2{" "}
          </Grid>
          <Grid item xs={2}>
            Doc 3
          </Grid> */}
          </Grid>
        </>
      )}
    </Paper>
  );
};

TableGrid.propTypes = {
  gridContent: PropTypes.object,
  isDocument: PropTypes.bool,
};

export default TableGrid;
